import styles from './Card.module.scss';

import React, { ReactNode, forwardRef } from 'react';
import { LinkProps } from '@reach/router';
import cx from 'clsx';

import { SmartLink } from 'components/SmartLink';

import { CARD_TEST_ID } from './CardTestIds';

type Element = HTMLAnchorElement | HTMLElement;

type CardProps<E extends Element> = React.AnchorHTMLAttributes<E> & Omit<LinkProps<Record<string, unknown>>, 'to'> & {
  children?: ReactNode;
  linkTo?: string;
};

export const Card = forwardRef(function Card<E extends Element>(props: CardProps<E>, ref: React.Ref<E>) {
  const { className, children, linkTo, onClick, ...rest } = props;
  const isLink = !!linkTo?.trim();
  const isButton = !isLink && !!onClick;

  const spreadableProps = {
    'data-testid': CARD_TEST_ID,
    'className': cx(styles.card, {
      [styles.cardClickable]: isLink || isButton
    }, className),
    onClick,
    ...rest,
  };

  if (isLink && linkTo) {
    return (
      <SmartLink to={linkTo} {...spreadableProps} ref={ref as any}>
        {children}
      </SmartLink>
    );
  }

  if (isButton) {
    return (
      <a {...(spreadableProps as unknown as React.AnchorHTMLAttributes<HTMLAnchorElement>)} ref={ref as React.Ref<HTMLAnchorElement>} >
        {children}
      </a>
    );
  }

  return (
    <section {...spreadableProps} ref={ref}>
      {children}
    </section>
  );
});
